import React from "react";
import styled from "styled-components";

// Styled components
const TableWrapper = styled.div`
  width: 100%;
  margin: 20px auto;
  text-align: center;
`;

const StyledTable = styled.table`
  width: 100%;
  font-size: 14px;
  border-collapse: collapse;
  background-color: ${(props) =>
    props.$light ? "#fff" : "var(--lightblack)"};
  color: ${(props) => (props.$light ? "#161616" : "var(--white)")};
`;

const StyledTh = styled.th`
  background-color: ${(props) => (props.$light ? "#14586a" : "var(--black)")};
  color: white;
  padding: 10px;
  border: 1px solid ${(props) => (props.$light ? "#0f4452" : "var(--darkgrey)")};
`;

const StyledTd = styled.td`
  padding: 10px;
  border: 1px solid ${(props) => (props.$light ? "#d5dde0" : "var(--darkgrey)")};
`;

const StyledTr = styled.tr`
  &:nth-child(even) {
    /* background-color: #f2f2f2; */
  }
`;

// Reusable table component
const TournamentDynamicTable = ({ tableData, variant = "dark" }) => {
  const { columns, rows } = tableData;
  const light = variant === "light";
  return (
    <TableWrapper>
      <StyledTable $light={light}>
        <thead>
          <StyledTr>
            {columns?.map((col, index) => (
              <StyledTh $light={light} key={index}>{col.name}</StyledTh>
            ))}
          </StyledTr>
        </thead>
        <tbody>
          {rows?.map((row, rowIndex) => (
            <StyledTr key={rowIndex}>
              {columns?.map((col, colIndex) => (
                <StyledTd $light={light} key={colIndex}>
                  {row[col.key] || ""}
                </StyledTd>
              ))}
            </StyledTr>
          ))}
        </tbody>
      </StyledTable>
    </TableWrapper>
  );
};

export default TournamentDynamicTable;
